import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {PageRequest, PageResult} from '../models/PageableModel';
import {BehaviorSubject, Observable} from 'rxjs';
import {FilterModel, MainModel} from '../models/GenericModel';
import {BaseService} from '../services/api/BaseService';

export abstract class BaseDataSource<T extends MainModel, F extends FilterModel> implements DataSource<T> {

  public pageModel = new PageRequest();
  public pageData = new PageResult<T>();

  filter: F;


  protected dataSubject: BehaviorSubject<T[]>;
  protected loadingSubject = new BehaviorSubject<boolean>(false);

  protected constructor(showPaginator: boolean, protected baseService: BaseService<T, F>) {
    this.showPagination = showPaginator == null ? false : showPaginator;
    this.dataSubject = new BehaviorSubject<T[]>([]);
  }

  public showPagination = false;

  public loading$ = this.loadingSubject.asObservable();

  connect(collectionViewer: CollectionViewer): Observable<T[]> {
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.dataSubject.complete();
    this.loadingSubject.complete();
  }

  loadData(filter?: F): void {
    if (filter) {
      this.filter = filter;
    }

    this.loadingSubject.next(true);

    this.pageModel.dataManipulation();

    this._loadData();
  }

  protected _loadData(): void {
    this.baseService.list(this.pageModel, this.filter)
      .then(result => {
        this.onSuccess(result.content);
        this.pageData = result;
      });
  }

  downloadXls(filter?: F) {
    return this.baseService.downloadXls(filter);
  }

  protected onSuccess(result: any[]): void {
    this.dataSubject.next(result);
    this.loadingSubject.next(false);
  }

  protected onError(): void {
    this.dataSubject.next([]);
    this.loadingSubject.next(false);
  }

  public hasNext(): boolean {
    return !this.pageData.last;
  }

  public hasPrev(): boolean {
    return !this.pageData.first;
  }

  public getTotalPages(): number {
    return this.pageData.totalPages;
  }

  public getTotalElements(): number {
    return this.pageData.totalElements;
  }

  public getCurrentPage(): number {
    return this.pageData.pageable.pageNumber;
  }

  public getElementsPerPage(): number {
    return this.pageData.size;
  }

  public getPageRequestModel(): PageRequest {
    return this.pageModel;
  }

  public nextPage(): void {
    this.pageModel.next();
  }

  public setPage(page: number): void {
    this.pageModel.page = page;
  }

  public prevPage(): void {
    this.pageModel.prev();
  }

  public setSize(size: number): void {
    this.pageModel.size = size;
  }
}
